import React from 'react'
import PropTypes from 'prop-types'
import { Icon, List, Progress } from 'antd'

import StudentTodoItem from './StudentTodoItem'

// TODO?! implement/utilize alert button w/ callback function?
class StudentTodoView extends React.Component {
  constructor (props) {
    super(props)
    this.renderItem = this.renderItem.bind(this)
  }

  renderItem (todoItem, i) {
    const highlighted = i === this.props.highlightedTodoIndex
    const listClassNames = highlighted
      ? 'highlighted-todo view-todo'
      : 'view-todo'

    return (
      <List.Item
        className={listClassNames}
        onClick={() => {
          this.props.highlightTodo(i)
        }}>
        <StudentTodoItem
          key={todoItem.id}
          todoItem={todoItem}
          highlighted={highlighted}
          index={i}
          updateTodoCompletion={completed => {
            this.props.updateTodoCompletion(todoItem.id, completed)
          }} />
      </List.Item>
    )
  }

  render () {
    const { todoItems } = this.props
    const numComplete = todoItems.filter(todoItem => todoItem.completed).length
    const percentComplete = Math.floor((100 * numComplete) / todoItems.length)
    const complete = percentComplete === 100
    const progressBarClassNames = complete
      ? 'complete-progress todo-progress'
      : 'todo-progress'
    const progressCheckClassNames = complete
      ? 'complete-progress-check todo-progress-check'
      : 'todo-progress-check'

    return (
      <section className='todo-app'>
        <span className='todo-description'>
          {this.props.listInfo.description}
        </span>
        <div className='todo-status-wrapper'>
          <Progress
            className={progressBarClassNames}
            percent={percentComplete}
            showInfo={false}
            strokeLinecap='square' />
          <Icon
            className={progressCheckClassNames}
            type='check-circle'
            theme='twoTone'
            twoToneColor='#70C060' />
          {this.props.todoItems.length > 0 && (
            <List
              className='todo-list'
              size='large'
              dataSource={this.props.todoItems}
              renderItem={this.renderItem} />
          )}
        </div>
      </section>
    )
  }
}

StudentTodoView.propTypes = {
  highlightedTodoIndex: PropTypes.number.isRequired,
  highlightTodo: PropTypes.func.isRequired,
  listInfo: PropTypes.shape({ description: PropTypes.string.isRequired })
    .isRequired,
  todoItems: PropTypes.arrayOf(
    PropTypes.shape({
      completed: PropTypes.bool.isRequired,
      id: PropTypes.string.isRequired
    })
  ).isRequired,
  updateTodoCompletion: PropTypes.func.isRequired
}

export default StudentTodoView



// WEBPACK FOOTER //
// ./src/components/StudentTodoView.js